import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // Add React bindings as a plugin.
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  // Initialize the i18next instance.
  .init({
    // Config options

    // Specifies the default language (locale) used
    // when a user visits our site for the first time.
    // We use English here, but feel free to use
    // whichever locale you want.
    lng: 'tr',

    // Fallback locale used when a translation is
    // missing in the active locale. Again, use your
    // preferred locale here.
    fallbackLng: 'tr',

    // Enables useful output in the browser’s
    // dev logger.
    debug: true,

    // Normally, we want `escapeValue: true` as it
    // ensures that i18next escapes any code in
    // translation messages, safeguarding against
    // XSS (cross-site scripting) attacks. However,
    // React does this escaping itself, so we turn
    // it off in i18next.
    interpolation: {
      escapeValue: false,
    },

    // Translation messages. Add any languages
    // you want here.
    resources: {
      // Turkish
      tr: {
        // `translation` is the default namespace.
        // More details about namespaces shortly.
        translation: {
          hello_world: 'Merhaba, Dünya!',
          save_changes: 'DEĞİŞİKLİKLERİ KAYDET',
          general_settings: 'Genel Ayarlar',
          siteName: 'Site Adı',
          siteDescription: 'Site Açıklaması',
          phones: 'İletişim Numaraları',
          email: 'E-posta',
          socialLinks: 'Sosyal Medya Linkleri',
          faqs: 'SSS',
          about: 'Hakkında',
          aboutOnlineEducation: 'Online Atölyeler Hakkında',
          aboutFidctionalEducation: 'Kurgusal Etkinlikler Hakkında',
          packages: 'Abonelikler',
          companyInfo: 'Firma Bilgileri',
          paymentMethods: 'Ödeme Yöntemleri',
          add_item: 'Ekle',
          name: 'ad',
          icon: 'ikon/logo',
          question: 'soru',
          answer: 'cevap',
          title: 'başlık',
          Title: 'Başlık',
          content: 'içerik',
          descripiton: 'açıklama',
          description: 'Açıklama',
          Description: 'Açıklama',
          Interval: 'Süre (ms) 1000 = 1 saniye',
          Transparency: 'Transparanlık (%)',
          price: 'fiyat',
          items: 'itemler',
          policy: 'şartlar',
          order: 'sıra',
          Order: 'Sıra',
          add: 'Ekle',
          Image: 'Görsel',
          add_new_image: 'Yeni Görsel Ekle',
          address: 'adres',
          host: 'host',
          endpoint: 'adres',
          isActive: 'aktif mi',
          edit: 'Düzenle',
          cancel: 'Vazgeç',
          submit: 'Gönder',
          add_seo_tag: 'SEO Etiket Ekle',
          add_image: 'Görsel Ekle',
          value: 'değer',
          key: 'anahtar',
          edit_settings: 'Ayarı Düzenle',
          İyzico: 'İyzico',
          tosla: 'Tosla',
          href: 'href',
          kvkkEmail: 'KVKK E-Postası',
          Update: 'Güncelle',
          Name: 'Ad',
          Surname: 'Soyad',
          Email: 'E-Posta',
          Password: 'Şifre',
          identityNumber: 'Kimlik Numarası',
          Phone: 'Telefon',
          Status: 'Durum',
          Role: 'Rol',
          profileImage: 'Profil Resmi',
          updateUser: 'Kullanıcı Güncelle',
          password: 'Şifre',
          rePassword: 'Şifre Tekrarı',
          forgotPassword: 'ŞİFREMİ Unuttum',
          resetPassword: 'Şİfremİ Değiştir',
        },
      },
      // English
      en: {
        // `translation` is the default namespace.
        // More details about namespaces shortly.
        translation: {
          hello_world: 'Hello, World!',
          save_changes: 'Save Changes',
          general_settings: 'General Settings',
        },
      },
      // Arabic
      ar: {
        translation: {
          hello_world: 'مرحباً بالعالم!',
          save_changes: 'حفظ التغييرات',
          general_settings: 'الاعدادات العامة',
        },
      },
    },
  });

export default i18n;
